import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import _ from 'lodash';
import { withRouter } from 'react-router';

import classes from '@nerdwallet/base-styles/classes';
import { Button, List, Li, Title, Type } from '@nerdwallet/currency';
import HtmlToNDS from '@nerdwallet/react-html-to-nds';
import grnhseTrackingCheck from '../../../lib/company-content-src/grnhse-tracking-check';

const CompanyJob = ({ job, location: routerLocation }) => {
  const { id, content, title, location } = job;
  const careersPath = '/careers';

  return (
    <div>
      <div
        className={classNames([
          'job__hdr--cont',
          classes('display-flex'),
          classes('flex-direction-row'),
          classes('justify-content-space-between'),
          classes('padding-bottom-4'),
          classes('margin-horizontal-3'),
          classes('margin-horizontal-auto--wide'),
          classes('border-bottom-1'),
          classes('border-neutral-lighter'),
          classes('margin-vertical-4'),
          classes('align-items-baseline'),
        ])}
      >
        <div className={classNames(['job__hdr--left'])}>
          <Button
            default
            href={grnhseTrackingCheck(careersPath, routerLocation.search)}
            className={classNames([
              'job__hdr--link',
              classes('color-nw-green'),
            ])}
          >
            All listings
          </Button>
        </div>
        <div
          className={classNames([
            'job__hdr--right',
            classes('display-flex'),
            classes('flex-direction-row'),
            classes('align-items-baseline'),
          ])}
        >
          <Type
            size="2"
            default
            className={classNames([
              'departments__description',
              classes('margin-right-3--wide'),
            ])}
          >
            {_.get(location, 'name')}
          </Type>
          <div
            className={classNames([
              'job__hdr--apply-desk',
              classes('display-block--wide'),
              classes('display-none'),
            ])}
          >
            <Button primary href="#applyJob">
              Apply now
            </Button>
          </div>
        </div>
      </div>
      <div
        className={classNames([
          'job__hdr--apply-mobile',
          classes('display-block'),
          classes('display-none--wide'),
          classes('margin-horizontal-3'),
          classes('margin-bottom-4'),
        ])}
      >
        <Button
          primary
          href="#applyJob"
          className={classNames(['job__hdr--apply-desk', classes('width-100')])}
        >
          Apply now
        </Button>
      </div>
      <div
        key={id}
        className={classNames([
          'job__cont',
          classes('margin-horizontal-auto--wide'),
        ])}
      >
        <div>
          <Type
            size="4"
            chronicle
            className={classNames([
              'job__title',
              classes('text-align-center'),
              classes('margin-horizontal-3'),
              classes('margin-horizontal-auto--wide'),
              classes('margin-bottom-4'),
            ])}
          >
            {title}
          </Type>
        </div>
        <div
          className={classNames([
            'job__content',
            classes('text-small'),
            classes('margin-horizontal-3'),
            classes('margin-horizontal-auto--wide'),
            classes('margin-bottom-5'),
          ])}
        >
          <HtmlToNDS
            html={content}
            decode
            componentDict={{
              h3: (node, children) => (
                <Title className={classes(['margin-top-4', 'margin-bottom-3'])}>
                  {children}
                </Title>
              ),
              p: (node, children) => (
                <Type className={classes(['margin-bottom-3'])}>{children}</Type>
              ),
              ul: (node, children) => (
                <List className={classNames([classes(['margin-bottom-3'])])}>
                  {children}
                </List>
              ),
              li: (node, children) => <Li>{children}</Li>,
            }}
          />
        </div>
      </div>
    </div>
  );
};

CompanyJob.propTypes = {
  id: PropTypes.number,
  content: PropTypes.string,
  title: PropTypes.string,
  location: PropTypes.object,
  job: PropTypes.shape({
    id: PropTypes.number,
    content: PropTypes.string,
    title: PropTypes.string,
    location: PropTypes.shape({
      name: PropTypes.string,
    }),
  }),
};

CompanyJob.displayName = 'Company Job';

const CompanyJobWithRouter = withRouter(CompanyJob);

export default CompanyJobWithRouter;
